
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none"><path fill="#000" d="M20.675 2.625H3.383a.75.75 0 0 0-.752.75v17.25c0 .415.336.75.752.75h17.292a.75.75 0 0 0 .752-.75V3.375a.75.75 0 0 0-.752-.75ZM4.323 4.313h3.195v15.375H4.323V4.313Zm15.412 15.375H9.022V9h10.713v10.688ZM9.022 7.5V4.312h10.713V7.5H9.022Z"/></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    